export const TYPES = {
  RESKILLING: 'RESKILLING',
  UPSKILLING: 'UPSKILLING',
  SELFDIAGNOSIS: 'SELFDIAGNOSIS',
  MODELS: 'MODELS',
}
